module.exports = __webpack_public_path__ + "fonts/b35c496.ttf";